module.exports = __webpack_public_path__ + "static/img/15.2e030f61.png";